import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {TranslateService} from '@brunata-angular/util';
import {getRouteLabel} from '@shared/route-utils';

@Component({
    selector: 'app-installation-project-detail',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, RouterOutlet],
    template: `
        <ul class="nav nav-tabs justify-content-start">
            @for (tab of tabs; track tab.route) {
                <li class="nav-item">
                    <a class="nav-link" routerLinkActive="active" [routerLink]="tab.route">
                        {{ tab.label }}
                    </a>
                </li>
            }
        </ul>

        <router-outlet />
    `,
})
export class InstallationProjectDetailComponent {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly translateService = inject(TranslateService);

    /** One tab per child route with a path - the path-less child only redirects to the first
     * tab. The remaining tabs of the mock (Order & materials, Mail archive) arrive with their
     * stories, and the project header line with AGI-19636. */
    protected readonly tabs = (this.activatedRoute.routeConfig?.children ?? [])
        .filter(child => child.path != null && child.path !== '')
        .map(child => ({
            route: child.path ?? '',
            label: getRouteLabel(child, this.translateService),
        }));
}
